import { queryOptions } from '@tanstack/react-query';

import {
  fetchCompetitionStructure,
  fetchDomesticCompetitions,
  fetchRoundParticipants,
  fetchRounds,
  fetchTeamCompetitions,
} from '@apis/competition';

export const getCompetitionStructureQuery = (params: Parameters<typeof fetchCompetitionStructure>[0]) =>
  queryOptions({
    queryKey: ['competition-structure', params],
    queryFn: ({ signal }) => fetchCompetitionStructure(params, signal),
  });

export const getRoundParticipantsQuery = (params: Parameters<typeof fetchRoundParticipants>[0]) =>
  queryOptions({
    queryKey: ['round-participants', params],
    queryFn: ({ signal }) => fetchRoundParticipants(params, signal),
    placeholderData: [],
  });

export const getDomesticCompetitionsQuery = (params: Parameters<typeof fetchDomesticCompetitions>[0]) =>
  queryOptions({
    queryKey: ['domestic-competitions', params],
    queryFn: ({ signal }) => fetchDomesticCompetitions(params, signal),
  });

export const getTeamCompetitionsQuery = (params: Parameters<typeof fetchTeamCompetitions>[0]) =>
  queryOptions({
    queryKey: ['team-competitions', params],
    queryFn: ({ signal }) => fetchTeamCompetitions(params, signal),
    placeholderData: [],
  });

export const getRoundsQuery = (params: Parameters<typeof fetchRounds>[0]) =>
  queryOptions({
    queryKey: ['rounds', params],
    queryFn: ({ signal }) => fetchRounds(params, signal),
    placeholderData: [],
  });
